import { Dialog, DialogTrigger } from '@/components/atoms/Dialog';
import { Checkbox } from '@/components/atoms/PcCheckbox';
import { SIGNUP_TERMS } from '@/constants/signup-terms';
import { cn } from '@/utils/tailwind';
import { TermsDialogContent } from './terms-dialog-content';

interface Props {
  checkedItems: boolean[];
  handleAllCheck: () => void;
  handleSingleCheck: (index: number) => void;
  compact?: boolean;
}

export const SignupTerms = ({
  checkedItems,
  handleAllCheck,
  handleSingleCheck,
  compact = false,
}: Props) => {
  const allChecked = checkedItems.every(Boolean);

  return (
    <div className="w-full space-y-3">
      <div className="flex w-full items-center gap-2 text-left">
        <Checkbox checked={allChecked} onCheckedChange={handleAllCheck} />
        <span className={cn('font-semibold text-gr-800 max-md:Body4S14', compact && 'Body4S14')}>
          서비스 이용약관 전체 동의
        </span>
      </div>
      {SIGNUP_TERMS.map((terms, i) => (
        <div key={terms.label} className="flex min-h-[22px] items-center gap-2">
          <Checkbox checked={checkedItems[i]} onCheckedChange={() => handleSingleCheck(i)} />{' '}
          <div className="flex min-w-0 items-center gap-1">
            <span className="text-gr-700 Caption1M12">[{terms.isOptional ? '선택' : '필수'}]</span>
            <span className={cn('text-gr-700 Body5M14', compact && 'Caption1M12')}>
              {terms.label}
            </span>
          </div>
          <Dialog>
            <DialogTrigger className="shrink-0 text-gr-600 underline underline-offset-2 Caption1M12">
              전문보기
            </DialogTrigger>
            <TermsDialogContent content={terms.termsContent} />
          </Dialog>
        </div>
      ))}
    </div>
  );
};
